// extracted by mini-css-extract-plugin
export default {"marker":"UsjYRxmS3e7uSsSgT1PS"};